import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <defs>
      <path
        id="path-icon-ball-possession"
        d="M9 0a9 9 0 110 18A9 9 0 019 0zm0 1.8c-1.11 0-2.162.251-3.1.7l-.932 2.734-2.108.004A7.166 7.166 0 001.8 9c0 .689.097 1.355.277 1.986l3.161 2.093-.66 1.603a7.169 7.169 0 005.037 1.492l2.141-1.895 1.01.858a7.212 7.212 0 003.232-4.436l-1.391-2.778 1.31-.926a7.203 7.203 0 00-2.155-3.398l-3.34.001-.412-1.73A7.262 7.262 0 009 1.8zm-.162 3.6l3.27 2.376-1.249 3.844H6.817L5.568 7.776 8.838 5.4z"
      />
    </defs>
    <g fill="none">
      <g transform="translate(5 7)">
        <mask id="mask-icon-ball-possession" fill="#fff">
          <use href="#path-icon-ball-possession" />
        </mask>
        <use fill="#FFC100" href="#path-icon-ball-possession" />
        <g fill="#051045" mask="url(#mask-icon-ball-possession)">
          <path d="M-1-1h20v20H-1z" />
        </g>
      </g>
      <circle cx="6" cy="6" r="6" fill="#73B0D7" transform="translate(18.5 6)" />
      <path
        fill="#FFF"
        d="M22.562 12.216c.197 0 .389-.033.576-.1a1.468 1.468 0 00.862-.804c.089-.2.133-.435.133-.704 0-.27-.044-.505-.133-.705a1.468 1.468 0 00-.862-.804 1.725 1.725 0 00-1.152 0 1.429 1.429 0 00-.5.3 1.501 1.501 0 00-.353.504c-.089.2-.133.435-.133.705 0 .27.044.504.133.705.09.2.207.368.353.503s.312.235.5.3c.187.067.38.1.576.1zm.228 2.775a.63.63 0 00.281-.063.484.484 0 00.205-.188l3.372-5.524a1.8 1.8 0 00-.181-.104.625.625 0 00-.286-.058.503.503 0 00-.457.26l-3.381 5.524c.057.036.125.07.205.104.079.033.16.049.242.049zm-.228-3.485c-.152 0-.273-.072-.362-.216-.089-.143-.133-.368-.133-.673 0-.306.044-.529.133-.67a.41.41 0 01.362-.21c.146 0 .265.07.357.21.092.141.138.364.138.67 0 .305-.046.53-.138.673-.092.144-.211.216-.357.216zM26.429 15c.196 0 .388-.033.576-.099a1.468 1.468 0 00.862-.804c.089-.2.133-.435.133-.705 0-.27-.044-.504-.133-.705a1.468 1.468 0 00-.862-.804 1.725 1.725 0 00-1.153 0 1.429 1.429 0 00-.5.301 1.501 1.501 0 00-.352.503c-.089.2-.133.436-.133.705 0 .27.044.505.133.705a1.429 1.429 0 00.852.804c.188.066.38.099.577.099zm0-.71c-.153 0-.273-.071-.362-.215-.09-.144-.134-.368-.134-.674 0-.305.045-.528.134-.669a.41.41 0 01.362-.211c.146 0 .265.07.357.211.092.14.138.364.138.67 0 .305-.046.53-.138.673-.092.144-.211.215-.357.215z"
      />
    </g>
  </svg>
);

const IconBallPossession = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconBallPossession;
